import { DRAWING_HANDLE_EDGE_INSET_PX } from "./drawingConstants";
import { pixelToPoint } from "./drawingPoints";

/**
 * Where a tool puts its new drawing: the shares of `tool.defaultPoints`
 * (po-chart-visual-spec.md §7.5) are of the width of the chart with the price
 * axis and of the height of the price pane, so oscillator panes do not push a drawing
 * away. A point right of the last bar continues with the bar duration (timeIndex.js).
 * A narrow chart would put a point under the price axis, it stays reachable next to it.
 *
 * @param {{ defaultPoints: number[][] }} tool
 * @param {object} view - see createDrawings
 * @returns {Array<{ time: number, price: number }> | null} null until the chart has bars and a size
 */
export const placeDrawingPoints = ({ defaultPoints }, view) => {
  const { store, timeScale, priceScale, chartWidth } = view;

  if (!store.length || !chartWidth || !priceScale.height) return null;

  const maxX = timeScale.width - DRAWING_HANDLE_EDGE_INSET_PX;

  return defaultPoints.map(([widthShare, heightShare]) =>
    pixelToPoint({ x: Math.min(widthShare * chartWidth, maxX), y: heightShare * priceScale.height }, view),
  );
};
